var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'hashead':!_vm.isPC}},[(!_vm.isPC)?_c('WapHeader',{attrs:{"title":'',"showhome":true,"showlogo":true}}):_vm._e(),_vm._v(" "),_c('HotRecom',{staticClass:"bmain",attrs:{"isPC":_vm.isPC}}),_vm._v(" "),_c('Footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78a0e283","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RecommendList.vue
// module id = null
// module chunks = 